import routerOptions0 from "/builds/aschehoug/aschehoug-utdanning/shop-app/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.0_@vue+compiler-sfc@3.5.21_aws4fetch@1.0.20_db0@0.3.2_eslint@9_gd4xzc7kim7efqofxkqkqwp5gi/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}